import { Link } from 'react-router-dom';
import type { Manga } from '@/mocks/manga';

interface MangaCardProps {
  manga: Manga;
  showCategory?: boolean;
}

export default function MangaCard({ manga, showCategory = true }: MangaCardProps) {
  const formatViews = (views: number): string => {
    if (views >= 10000) {
      return `${(views / 10000).toFixed(1)}万`;
    }
    return views.toString();
  };

  return (
    <Link
      to={`/manga/${manga.slug}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={manga.coverImage}
          alt={`${manga.title} - 亲亲漫画免费在线阅读`}
          title={`${manga.title} - 亲亲漫画${manga.category}免费全集下拉式在线阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <span className="text-xs text-white font-medium bg-primary-500/90 px-2 py-1 rounded-md whitespace-nowrap">
            点击查看详情
          </span>
        </div>
        <div className="absolute top-2 left-2 flex flex-col gap-1">
          {showCategory && (
            <span className="text-[10px] font-medium text-white bg-accent-500/90 px-2 py-0.5 rounded-full whitespace-nowrap">
              {manga.category}
            </span>
          )}
          {manga.status === '已完结' && (
            <span className="text-[10px] font-medium text-white bg-secondary-500/90 px-2 py-0.5 rounded-full whitespace-nowrap">
              完结
            </span>
          )}
        </div>
        <div className="absolute top-2 right-2">
          <span className="text-[10px] font-semibold text-white bg-black/50 px-1.5 py-0.5 rounded-md flex items-center gap-0.5 whitespace-nowrap">
            <i className="ri-star-fill text-[8px] text-accent-500"></i>
            {manga.rating}
          </span>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1 mb-1">
        {manga.title}
      </h3>
      <p className="text-xs text-foreground-500 line-clamp-1">
        {manga.author} · {formatViews(manga.views)}次阅读
      </p>
    </Link>
  );
}